
<template>
   <v-layout row wrap>
      <v-flex :class="listCss">
         <user-list
            :title="title"
            :users="coachedUsers"
            :selectedUserId="selectedUserId"
            :canAdd="false"
            @addUser="addUserDialog = true"
            @deleteUser="deleteUser"
            @userSelected="userSelected"
         />
      </v-flex>

      <v-flex :class="detailCss">
         <router-view
            @userIdChanged="userIdChanged"
         ></router-view>
      </v-flex>

      <v-dialog v-model="addUserDialog" persistent max-width="400">
         <v-form v-model="valid" ref="form" lazy-validation>
            <v-card>
               <v-card-title class="headline grey lighten-2">Ajout d'un utilisateur</v-card-title>
               <v-card-text>
                  <v-container grid-list-md>
                     <v-layout wrap>
                        <v-flex xs12>
                           <v-autocomplete
                              label="Patient"
                              :loading="loading"
                              cache-items
                              item-text="fullname"
                              item-value="id"
                              required
                              :items="items"
                              :search-input.sync="search"
                              v-model="userToAddId"
                           ></v-autocomplete>
                        </v-flex>
                     </v-layout>
                  </v-container>
               </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="brown darken-2" flat @click.native="addUserDialog = false; addUser()" :disabled="!valid">OK</v-btn>
                  <v-btn color="brown darken-2" flat @click.native="addUserDialog = false">Annuler</v-btn>
               </v-card-actions>
            </v-card>
         </v-form>
      </v-dialog>
      
   </v-layout>
</template>


<script>
   import config from '@/config'
   //import _ from 'lodash'
   const axios = require("axios")

   import UserList from '@/components/users/UserList'

   export default {

      components: {
         UserList: UserList,
      },

      props: {
         title: String,
         baseRoute: String,
      },

      mounted: async function() {
         await this.$store.dispatch('GET_COACHED_USERS')
         let self = this
         this.$store.getters.coachedUsers.forEach(function(user) {
            self.$store.dispatch('COUNT_UNREAD_MESSAGES', user.id)
         })
      },

      data () {
         return {
            selectedUserId: null,
            addUserDialog: false,
            userToAddId: null,
            valid: false,
            items: [],
            search: null,
            select: [],
            loading: false,
         }
      },

      computed: {
         listCss () {
            //return { xs12: true, sm2: this.selectedUserId, sm4: !this.selectedUserId }
            return { xs12: true, sm3: true }
         },
         detailCss () {
            //return { xs12: true, sm10: this.selectedUserId, sm8: !this.selectedUserId }
            return { xs12: true, sm9: true }
         },

         coachedUsers: function() {
            return this.$store.getters.coachedUsers
         }
      },

      watch: {
         search (val) {
            val && this.querySelections(val)
         }
      },

      methods: {
         userIdChanged (userId) {
            this.selectedUserId = userId
         },

         userSelected (userId) {
            // fetch user's profile
            this.$store.dispatch('GET_USER', userId)
            // change route
            this.$router.push(this.baseRoute + userId)
         },

         userMealsUpdated (userId) {
            console.log('selectedUserId', this.selectedUserId)
            this.selectedUserId = userId
         },

         // add `userToAddId` to the list of users coached by `loggedInUser`
         addUser: async function() {
            try {
               // get user record
               let user = await this.$store.dispatch('GET_USER', this.userToAddId)
               // add logged user caregiver to the list of coaches of `user`
               if (user.coaches.indexOf(this.$store.state.loggedUserId) === -1) {
                  // logged-in user is not in the list of coaches of `user` : adds it
                  // we use a copy to not update vuex state directly
                  let userCopy = _.cloneDeep(user)
                  userCopy.coaches.push(this.$store.state.loggedUserId)
                  // update user's record
                  await this.$store.dispatch('PUT_USER', userCopy)
                  // ask again the user list: reactivity will update list view
                  this.$store.dispatch('GET_COACHED_USERS')
               } else {
                  this.$store.commit('SNACKBAR', { timeout: 2500, text: "Cet utilisateur est déjà dans la liste", color: 'red' })
               }
            } catch(err) {
               this.$store.commit('SNACKBAR', { timeout: 2500, text: "Erreur inconnue lors de l'ajout", color: 'red' })
            }
         },

         deleteUser: async function(userId) {
            try {
               // get user record
               let user = await this.$store.dispatch('GET_USER', userId)
               // delete logged user caregiver to the list of doctors of `user`
               let index = user.coaches.indexOf(this.$store.state.loggedUserId)
               // we use a copy to not update vuex state directly
               let userCopy = _.cloneDeep(user)
               userCopy.coaches.splice(index, 1)
               // update user's record
               await this.$store.dispatch('PUT_USER', userCopy)
               // ask again the user list: reactivity will update list view
               this.$store.dispatch('GET_COACHED_USERS')
            } catch(err) {
               console.log(err)
            }
         },

         async querySelections (text) {
            let authData = this.$store.state.authenticationData
            let response = await axios({
               method: 'get',
               url: `${config.USERS_URL}?search=${text}`,
               headers: {"Authorization": `JWT ${authData.token}`},
            })
            this.items = response.data
         },
      },
   };
</script>



// WEBPACK FOOTER //
// Coaching.vue?43e66c22